import React from "react";
type ClosingWordsProps = {
  words: string[];
  size?: "sm" | "lg";
  className?: string;
};
const palette = ["text-navy", "text-green", "text-teal", "text-rose"];
export function ClosingWords({
  words,
  size = "lg",
  className = ""
}: ClosingWordsProps) {
  const sizing = size === "lg" ? "text-xl md:text-3xl" : "text-sm md:text-base";
  return <p className={`flex flex-wrap justify-center gap-x-3 gap-y-1 font-display font-black uppercase tracking-tight ${sizing} ${className}`} data-id="element-65" data-mp="a3wmrjaxjyb1">
      {words.map((word, i) => <span key={word} className={palette[i % palette.length]} data-id="element-66" data-mp="3dniw6214ps8k" data-mpi={i}>
          {word}
        </span>)}
    </p>;
}